import omit from 'lodash.omit'
import FilterComponent from 'map/components/filters/Filters'

const Filters = ({ filters, setFilters, triggerSearch, toggleResultsView }) => {
    const onFilter = filter => {
        const { value } = filter

        if (filters[value]) {
            setFilters(omit(filters, value))
        } else {
            setFilters({
                ...filters,
                [value]: true,
            })
        }
        triggerSearch()
    }

    return <FilterComponent toggleResultsView={toggleResultsView} filters={filters} onFilter={onFilter} />
}

export default Filters
